module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-11-zoom.ce092003.png";